import { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import ScrollToTop from "../components/scrollToTop/scrollToTop";
import Login from "../views/dashboard/login/login";
import Admin from "../views/dashboard/admin/admin";
import Error404 from "../components/error404/error404";
import GuiaDeEstilos from "../views/guia-de-estilos/main";
import Assignment from "../views/dashboard/admin/export/assignment/assignment";
import AssignmentReservation from "../views/dashboard/admin/export/assignment/assignment-reservation";
import Montacargas from "../views/montacargas/montacargas";
import { reportErrorToBackend } from "../components/errorBoundary/ErrorBoundary";

// Componente para capturar y reportar errores de las rutas
const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    // Reportamos el error al backend automáticamente
    if (error) {
      reportErrorToBackend(error);
    }
  }, [error]);

  // Reutilizamos el componente 404 o podrías usar uno específico para errores 500
  return <Error404 />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/guia-de-estilos",
    element: <GuiaDeEstilos />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/dashboard",
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: "",
        element: <Navigate to="/" replace />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "admin",
        element: <Admin />,
      },
    ],
  },

  {
    path: "/assignment",
    element: <Assignment />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/assignment-reservation",
    element: <AssignmentReservation />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/montacargas",
    element: <Montacargas />,
    errorElement: <RouteErrorBoundary />,
  },
]);

const MyRoutes = () => (
  <RouterProvider router={router}>
    <ScrollToTop />
  </RouterProvider>
);

export default MyRoutes;
